export default class Remove_field_with_error {
  selector: string

  constructor() {
    this.selector = '[data-error-message], [data-field=with-error] input:not([autocomplete=off]), [data-field=with-error] select, [data-field=with-error] textarea'
  }

  /** Removes Rails field error wrappers as soon as the related field changes. */
  init() {
    document.addEventListener('change', this.#handleChange)
  }

  #handleChange = (event: Event) => {
    if (event.target instanceof HTMLElement && event.target.matches(this.selector)) {
      this.#remove(event.target)
    }
  }

  #remove(target: HTMLElement) {
    const errorId = target.dataset.errorMessage || target.getAttribute('id')
    let errorNode = target.closest('.field_with_errors')

    while (errorNode) {
      const children = Array.from(errorNode.childNodes)
      errorNode.replaceWith(...children)
      errorNode = target.closest('.field_with_errors')
    }
    if (errorId) {
      document.querySelectorAll('[data-field-error="' + errorId + '"]').forEach(element => {
        element.remove()
      })
    }
  }
}
